import Station from "../models/station";
import { toJsonObject } from "../utils/utils";
import { API, getList, getResponseList, httpDelete, httpGet, httpPost, httpPut } from "./axios";

async function getStations(queryData: any) {
    const converter = (json: JSON) => Station.fromJson(json);
    return await getResponseList(API.CSMS_STATION, '', queryData, converter);
}

export { getStations};